import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import HeightGraph from '../HeightGraph';
import s from './Height.css';
import mathUtils from '../../core/mathUtils';

const womenHeight = 162.1;
const womenSd = 7.1;
const menHeight = 175.9;
const menSd = 7.4;
const minSelectivity = 0;

class Height extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alpha: 0.1,
      unscaledSelectivity: minSelectivity + 1,
      mean: womenHeight,
      sd: womenSd,
    };
  }

  scaleSelectivity(x) {
    const base = 10 ** Math.floor(x);
    const exact = 10 ** x;
    return base * Math.round(exact / base);
  }

  handleAlphaAdjustment(evt) {
    this.setState({
      alpha: parseFloat(evt.target.value),
    });
  }

  handleSelectivityAdjustment(evt) {
    this.setState({
      unscaledSelectivity: parseFloat(evt.target.value),
    });
  }

  handleMenClick() {
    this.setState({
      mean: menHeight,
      sd: menSd,
    });
  }

  handleWomenClick() {
    this.setState({
      mean: womenHeight,
      sd: womenSd,
    });
  }

  renderForm() {
    return (
      <div className={s.form}>
        <div className={s.verticalInput}>
          <div>
            <input
              id="women"
              type="radio"
              name="gender"
              value="women"
              onChange={() => this.handleWomenClick()}
              checked={this.state.mean === womenHeight}
            />
            &nbsp; Women
          </div>
          <div className={s.topPadded}>
            <input
              id="men"
              type="radio"
              name="gender"
              value="men"
              onChange={() => this.handleMenClick()}
              checked={this.state.mean !== womenHeight}
            />
            &nbsp; Men
          </div>
        </div>
        &nbsp;&nbsp;
        <div className={s.verticalInput}>
          <div>
            Alpha: -1 &nbsp;
            <input
              id="alpha"
              type="range"
              value={this.state.alpha}
              min="-1.0"
              max="1.0"
              step="0.05"
              onChange={(evt) => this.handleAlphaAdjustment(evt)}
            />
            &nbsp; 1
          </div>
          <div>
            Selectivity: low&nbsp;
            <input
              id="selectivity"
              type="range"
              value={this.state.unscaledSelectivity}
              min={minSelectivity}
              max="7"
              step="0.5"
              onChange={(evt) => this.handleSelectivityAdjustment(evt)}
            />
            &nbsp; high
          </div>
        </div>
      </div>
    );
  }

  renderStats() {
    const selectivity = mathUtils.formatLargeNumber(
      this.scaleSelectivity(this.state.unscaledSelectivity),
    );
    const vari = this.state.alpha * this.state.alpha;
    return (
      <div>
        <p>
          Proportion of performance explained by height: {vari.toFixed(3)}
          <br />
          Selectivity (i.e., one in this many people can perform at this level): {selectivity}
        </p>
      </div>
    );
  }

  render() {
    const selectivity = this.scaleSelectivity(this.state.unscaledSelectivity);
    return (
      <div>
        {this.renderForm()}
        {this.renderStats()}
        <HeightGraph
          alpha={this.state.alpha}
          selectivity={selectivity}
          mean={this.state.mean}
          sd={this.state.sd}
        />
      </div>
    );
  }
}

export default withStyles(s)(Height);



// WEBPACK FOOTER //
// src/components/Height/Height.js